<section #chartContainer class="chart-container {{ name || type | camelToKebabCase }}-chart"></section>
